export const FNOL_CUSTOMER_ANSWER = {
  CUSTOMER_HAS_ANSWERED: 'CUSTOMER_HAS_ANSWERED',
  CUSTOMER_WILL_ANSWER_LATER: 'CUSTOMER_WILL_ANSWER_LATER',
  CUSTOMER_REFUSES_TO_ANSWER: 'CUSTOMER_REFUSES_TO_ANSWER',
};

export const FNOL_VEHICLE_DAMAGE = {
  NOT_COMMUNICATED: 'NOT_COMMUNICATED',
  YES: 'YES',
  NO: 'NO',
};

export const PUBLIC_API_VERSION = {
  V1: 'v1',
  V2: 'v2',
  V3: 'v3',
  V4: 'v4',
  V5: 'v5',
};

export const FNOL_ACCIDENT_REPORT = {
  NO: 'NO',
  EREPORT: 'EREPORT',
  SIGNED_BY_BOTH_PARTIES: 'SIGNED_BY_BOTH_PARTIES',
  DETAILED_REPORT: 'DETAILED_REPORT',
  NOT_COMMUNICATED: 'NOT_COMMUNICATED',
};

export const FNOL_ESTIMATED_RESPONSIBILITY = {
  NONE: 'NONE',
  HALF: 'HALF',
  FULL: 'FULL',
  NOT_IDENTIFIED: 'NOT_IDENTIFIED',
};

export const EVENT_DETAILS_FUEL_TYPE = { PETROL: 'PETROL', DIESEL: 'DIESEL', LPG: 'LPG', ELECTRIC: 'ELECTRIC' };
export const EVENT_DETAILS_VEHICLE_CONDITION = {
  CAN_ONLY_BE_PUSHED: 'CAN_ONLY_BE_PUSHED',
  CANNOT_BE_MOVED: 'CANNOT_BE_MOVED',
  CAN_BE_DRIVEN: 'CAN_BE_DRIVEN',
};

export const EVENT_DETAILS_DISASTER = {
  OTHER: 'OTHER',
  LANDSLIDE: 'LANDSLIDE',
  STORM: 'STORM',
  LIGHTNING: 'LIGHTNING',
  HAILSTORM: 'HAILSTORM',
  FLOOD: 'FLOOD',
  TREE_FELL: 'TREE_FELL',
  EARTHQUAKE: 'EARTHQUAKE',
  WILDFIRE: 'WILDFIRE',
};

export const EVENT_DETAILS_BREAKDOWN = {
  ANTENNA: 'ANTENNA',
  BODY: 'BODY',
  CAMERA: 'CAMERA',
  DOORS: 'DOORS',
  EXHAUST: 'EXHAUST',
  LIGHTS: 'LIGHTS',
  MIRRORS: 'MIRRORS',
  WHEEL: 'WHEEL',
  WINDSCREEN_WIPER: 'WINDSCREEN_WIPER',
  AIRBAG: 'AIRBAG',
  AUDIOVIDEO_DEVICE: 'AUDIOVIDEO_DEVICE',
  DASHBOARD: 'DASHBOARD',
  REAR_VIEW_MIRROR: 'REAR_VIEW_MIRROR',
  SEAT: 'SEAT',
  SEAT_BELT: 'SEAT_BELT',
  ACCELERATOR: 'ACCELERATOR',
  BRAKES: 'BRAKES',
  CLUTCH: 'CLUTCH',
  ENGINE: 'ENGINE',
  GEAR_BOX: 'GEAR_BOX',
  LEAKAGE: 'LEAKAGE',
  OVERHEATING: 'OVERHEATING',
  STEERING: 'STEERING',
  SUSPENSION: 'SUSPENSION',
  AIR_CONDITIONING_SYSTEM: 'AIR_CONDITIONING_SYSTEM',
  CENTRAL_LOCKING: 'CENTRAL_LOCKING',
  OTHER: 'OTHER',
  SMART_KEY: 'SMART_KEY',
};

export const MISSION_TYPE = {
  IMMEDIATE: 'IMMEDIATE',
  APPOINTMENT: 'APPOINTMENT',
};

export const EVENTS = {
  ACCIDENT: 'ACCIDENT',
  BATTERY_PROBLEM: 'BATTERY_PROBLEM',
  CRASH: 'CRASH',
  FIRE: 'FIRE',
  BAD_WEATHER: 'BAD_WEATHER',
  NATURAL_DISASTER: 'NATURAL_DISASTER',
  BREAKDOWN: 'BREAKDOWN',
  DRIVING_LICENCE_REVOCATION: 'DRIVING_LICENCE_REVOCATION',
  EMPTY_FUEL: 'EMPTY_FUEL',
  FLAT_TIRE: 'FLAT_TIRE',
  INFORMATIVE_CALL: 'INFORMATIVE_CALL',
  OTHER: 'OTHER',
  KEY_BROKEN: 'KEY_BROKEN',
  THEFT_ATTEMPT: 'THEFT_ATTEMPT',
  VANDALISM: 'VANDALISM',
  THEFT_BREAKIN: 'THEFT_BREAKIN',
  THEFT_WITH_KEYS: 'THEFT_WITH_KEYS',
  WINDSCREEN: 'WINDSCREEN',
  WRONG_FUEL: 'WRONG_FUEL',
  ROUTINE_MAINTENANCE: 'ROUTINE_MAINTENANCE',
  SAFETY_RECALL: 'SAFETY_RECALL',
  FROZEN_FUEL: 'FROZEN_FUEL',
  KEY_IN_CAR: 'KEY_IN_CAR',
  STUCK: 'STUCK',
  KEY_THEFT: 'KEY_THEFT',
  KEY_LOST: 'KEY_LOST',
};

export const VEHICLE_DESINATION_TYPE = {
  RECOMMENDED: 'RECOMMENDED',
  CUSTOM: 'CUSTOM',
  NONE: 'NONE',
};

export const VEHICLE_DESTINATION_NAME = {
  CUSTOM_VEHICLE_DESTINATION: 'CUSTOM',
};

export const VEHICLE_DESINATION_REASON = {
  CUSTOMER_REQUIRES_SPECIFIC_PROVIDER: 'CUSTOMER_REQUIRES_SPECIFIC_PROVIDER',
  NO_NETWORK_AVAILABLE: 'NO_NETWORK_AVAILABLE',
  OTHER: 'OTHER',
  CUSTOMER_REQUIRES_OFFICIAL_DEALER: 'CUSTOMER_REQUIRES_OFFICIAL_DEALER',
  NETWORK_RESULTS_NOT_SATISFACTORY: 'NETWORK_RESULTS_NOT_SATISFACTORY',
  LATER: 'LATER',
};

export const ERROR_CODES = {
  CLAIM_EVENT_MISSING: 'CLAIM_EVENT_MISSING',
  CLAIM_LOCATION_MISSING: 'CLAIM_LOCATION_MISSING',
  CLAIM_EVENT_DETAILS_MISSING: 'CLAIM_EVENT_DETAILS_MISSING',
  CLAIM_LOCATION_DETAILS_MISSING: 'CLAIM_LOCATION_DETAILS_MISSING',
  MISSION_ALREADY_EXISTS: 'MISSION_ALREADY_EXISTS',
  CLAIM_ANTERIORITY_ISSUE: 'CLAIM_ANTERIORITY_ISSUE',
  CLAIM_COVERAGE_ISSUE: 'CLAIM_COVERAGE_ISSUE',
  HOME_DISTANCE_ISSUE: 'HOME_DISTANCE_ISSUE',
  CLAIM_WARRANTY_ISSUE: 'CLAIM_WARRANTY_ISSUE',
  CRANE_REQUIRED: 'CRANE_REQUIRED',
  VEHICLE_IS_ON_A_HIGHWAY: 'VEHICLE_IS_ON_A_HIGHWAY',
  NO_SUITABLE_SERVICE_FOUND: 'NO_SUITABLE_SERVICE_FOUND',
  MISSION_OVERCOST: 'MISSION_OVERCOST',
  SERVICE_DOESNT_ALLOW_DISPATCH: 'SERVICE_DOESNT_ALLOW_DISPATCH',
  HIGHWAY_SECTIONS_NON_AVAILABLE: 'HIGHWAY_SECTIONS_NON_AVAILABLE',
  CANCEL_PREVIOUS_CLAIM_HANDLING: 'CANCEL_PREVIOUS_CLAIM_HANDLING',
  CANCEL_MILESTONE: 'CANCEL_MILESTONE',
  CANCEL_HIGHWAY_DIRECTION: 'CANCEL_HIGHWAY_DIRECTION',
  CANCEL_APPOINTMENT: 'CANCEL_APPOINTMENT',
  UPDATE_APPOINTMENT: 'UPDATE_APPOINTMENT',
  PROVIDER_NOT_ON_SPOT: 'PROVIDER_NOT_ON_SPOT',
  ADDITIONAL_SERVICE: 'ADDITIONAL_SERVICE',
  UNKNOWN_DESTINATION: 'UNKNOWN_DESTINATION',
  MISSION_IS_APPOINTMENT: 'MISSION_IS_APPOINTMENT',
  TECHNICAL_ERROR: 'TECHNICAL_ERROR',
  INTERNAL_SERVER_ERROR: 'INTERNAL_SERVER_ERROR',
  INCORRECT_VEHICLE_DESTINATION: 'INCORRECT_VEHICLE_DESTINATION',
  ADDITIONAL_TRANSPORTATION_NEEDED: 'ADDITIONAL_TRANSPORTATION_NEEDED',
  BENEFIT_COVERAGE_ISSUE: 'BENEFIT_COVERAGE_ISSUE',
  RENTAL_BENEFIT_COVERAGE_ISSUE: 'RENTAL_BENEFIT_COVERAGE_ISSUE',
  BO_CSC_BENEFIT_COVERAGE_ISSUE: 'BO_CSC_BENEFIT_COVERAGE_ISSUE',
  CLAIM_FNOL_MISSING: 'CLAIM_FNOL_MISSING',
  OTP_INVALID: 'OTP_INVALID',
  RESOURCE_ACCESS_ISSUE: 'RESOURCE_ACCESS_ISSUE',
  CLAIM_NOT_FOUND: 'CLAIM_NOT_FOUND',
  SUBSCRIPTION_UNDER_GRACE_PERIOD: 'SUBSCRIPTION_UNDER_GRACE_PERIOD',
  OPENED_CLAIM_ALREADY_EXISTS_GIVEN_THE_PLATE_NUMBER: 'OPENED_CLAIM_ALREADY_EXISTS_GIVEN_THE_PLATE_NUMBER',
  EVENT_TO_POLICY_ADDRESS_EXCEEDED: 'EVENT_TO_POLICY_ADDRESS_EXCEEDED',
  OVER_DISTANCE_LIMIT_EXCEEDED: 'OVER_DISTANCE_LIMIT_EXCEEDED',
  VEHICLE_IS_ON_AN_UNAUTHORIZED_HIGHWAY: 'VEHICLE_IS_ON_AN_UNAUTHORIZED_HIGHWAY',
  FRAUD_ALERT: 'FRAUD_ALERT',
  RENTAL_CAR_BENEFITS_NOT_COVERED: 'RENTAL_CAR_BENEFITS_NOT_COVERED',
  NEW_END_DATE_ON_A_WEEKEND: 'NEW_END_DATE_ON_A_WEEKEND',
  RENTAL_DURATION_LIMIT_EXCEEDED: 'RENTAL_DURATION_LIMIT_EXCEEDED',
};

export const NPS_CONSENT_ANSWER = {
  YES: 'YES',
  NO: 'NO',
};

export const CLAIM_STATE = {
  ACTIVE: 'ACTIVE',
  SENT_TO_REPORTING: 'SENT_TO_REPORTING',
  SENT_TO_INVOICING: 'SENT_TO_INVOICING',
  INVOICED: 'INVOICED',
  REGULATORY_CONSTRAINT: 'REGULATORY_CONSTRAINT',
  ON_BUSINESS_PARTNER_DEMAND: 'ON_BUSINESS_PARTNER_DEMAND',
  OTHER: 'OTHER',
};

export const CLAIM_STATUS = {
  OPENED: 'OPENED',
  CANCELLED: 'CANCELLED',
  CLOSED: 'CLOSED',
  DENIED: 'DENIED',
  OTHER: 'OTHER',
};

export const CLAIM_SUBSTATUS = {
  IN_PROGRESS: 'IN_PROGRESS',
  UNDER_INVESTIGATION: 'UNDER_INVESTIGATION',
  CLAIM_CORRECTION: 'CLAIM_CORRECTION',
  DUPLICATED_CLAIM: 'DUPLICATED_CLAIM',
  CUSTOMER_NO_LONGER_WANTS_SERVICE: 'CUSTOMER_NO_LONGER_WANTS_SERVICE',
  POSSIBLE_REQUEST: 'POSSIBLE_REQUEST',
  ASSISTANCE_DELIVERED: 'ASSISTANCE_DELIVERED',
  ASSISTANCE_CANCELLED: 'ASSISTANCE_CANCELLED',
  TRANSFERRED_TO_OEM: 'TRANSFERRED_TO_OEM',
  CONTROL_LIST: 'CONTROL_LIST',
  NOT_COVERED: 'NOT_COVERED',
  ERROR_OR_INTERNAL_TEST: 'ERROR_OR_INTERNAL_TEST',
};

export const MISSION_STATUS = {
  ACCEPTED: 'ACCEPTED',
  CANCELLED: 'MISSION_CANCELLED',
  DISPATCHED: 'DISPATCHED',
  END: 'END_OF_MISSION',
  IN_CREATION: 'IN_CREATION',
  INTERMEDIARY_STOP: 'INTERMEDIARY_STOP',
  ON_SPOT: 'ON_SPOT',
  PENDING: 'PENDING',
  REJECTED: 'REJECTED',
  START_TOW: 'START_TOW',
  STARTED: 'STARTED',
  TIMEOUT: 'TIMEOUT',
  MISSION_REFUSED: 'MISSION_REFUSED',
  // Legacy mission statuses
  READY: 'READY',
  OPERATOR_CANCELLED: 'OPERATOR_CANCELLED',
  OPERATOR_FORCE_CANCELLED: 'OPERATOR_FORCE_CANCELLED',
  ETA_EXPIRED: 'ETA_EXPIRED',
};

export const HISTORY_EVENTS = {
  MISSION_ACCEPTED: 'MISSION_ACCEPTED',
  MISSION_CANCELLED: 'MISSION_CANCELLED',
  TOW_STARTED: 'TOW_STARTED',
  EVENT: 'EVENT',
  LOCATION: 'LOCATION',
  VEHICLE_IMMOBILISATION_ADDED: 'VEHICLE_IMMOBILISATION_ADDED',
  VEHICLE_DESTINATION_SELECTED: 'VEHICLE_DESTINATION_SELECTED',
  PROVIDER_SELECTED: 'PROVIDER_SELECTED',
  INTERMEDIATE_STOP_SELECTED: 'INTERMEDIATE_STOP_SELECTED',
  INTERMEDIATE_STOP_REACHED: 'INTERMEDIATE_STOP_REACHED',
  INTERMEDIATE_STOP_CLEARED: 'INTERMEDIATE_STOP_CLEARED',
  MISSION_DRAFT_CREATED: 'MISSION_DRAFT_CREATED',
  MISSION_DRAFT_DELETED: 'MISSION_DRAFT_DELETED',
  MISSION_DIGITAL_EXITED: 'MISSION_DIGITAL_EXITED',
  MISSION_COPIED: 'MISSION_COPIED',
  RENTAL_BOOKING_DETAILS_UPDATED: 'RENTAL_BOOKING_DETAILS_UPDATED',
};

export const CAPTCHA_ACTIONS = {
  REQUEST_OTP: 'REQUEST_OTP',
};

export const BENEFITS = {
  REPLACEMENT_CAR: 'REPLACEMENT_CAR',
  RETURN_HOME: 'RETURN_HOME',
  TRIP_CONTINUITY: 'TRIP_CONTINUITY',
  OTHER: 'OTHER',
};

export const VEHICLE_OTHER_LOCATION = {
  OTHER_GARAGE: 'OTHER_GARAGE',
  ON_THE_WAY_TO_THE_GARAGE: 'ON_THE_WAY_TO_THE_GARAGE',
  OTHER: 'OTHER',
};

export const RENTAL_BOOKING_MODIFIER = {
  OPERATOR: 'OPERATOR',
  DIGITAL: 'DIGITAL',
};
